export default {
  components: {},

  data() {
    return {
      auth: ''
    };
  },

  created() {},

  methods: {}
};